var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCardOutlineSharp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.125H11.875V6.875H8.75V8.125ZM8.75 6.25H11.875V5H8.75V6.25ZM3.125 10H8.125V9.65625C8.125 9.1875 7.89583 8.81521 7.4375 8.53938C6.97917 8.26354 6.375 8.12542 5.625 8.125C4.875 8.12458 4.27083 8.26271 3.8125 8.53938C3.35417 8.81604 3.125 9.18833 3.125 9.65625V10ZM5.625 7.5C5.96875 7.5 6.26312 7.37771 6.50813 7.13313C6.75313 6.88854 6.87542 6.59417 6.875 6.25C6.87458 5.90583 6.75229 5.61167 6.50813 5.3675C6.26396 5.12333 5.96958 5.00083 5.625 5C5.28042 4.99917 4.98625 5.12167 4.7425 5.3675C4.49875 5.61333 4.37625 5.9075 4.375 6.25C4.37375 6.5925 4.49625 6.88688 4.7425 7.13313C4.98875 7.37937 5.28292 7.50167 5.625 7.5ZM1.25 12.5V2.5H13.75V12.5H1.25ZM2.5 11.25H12.5V3.75H2.5V11.25Z",
    fill: "#4049D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardOutlineSharp);
export default __webpack_public_path__ + "static/media/id-card-outline-sharp.141d189a5bdfa2966ad99b8635d70c27.svg";
export { ForwardRef as ReactComponent };